import React from 'react';
import { AppBar, Tabs, Tab, Toolbar, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

interface HeaderProps {
  isLoggedIn: boolean;
}

const Header: React.FC<HeaderProps> = ({ isLoggedIn }) => {
  const location = useLocation();

  const tabs = [
    { label: 'Map', path: '/' },
    ...(isLoggedIn ? [{ label: 'Profile', path: '/profile' }] : [{ label: 'Login', path: '/login' }]),
  ];

  const selectedTab = tabs.findIndex((tab) => tab.path === location.pathname);

  return (
    <AppBar position="static" color="primary">
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          Bread Reckoning
        </Typography>
        <Tabs
          value={selectedTab !== -1 ? selectedTab : false}
          textColor="inherit"
          indicatorColor="secondary"
        >
          {tabs.map((tab) => (
            <Tab key={tab.path} label={tab.label} component={Link} to={tab.path} />
          ))}
        </Tabs>
      </Toolbar>
    </AppBar>
  );
};

export default Header;